<template lang="pug">
article.locations-show
  CommonHeader(
    :id="location.id"
    :routeName="'locations'"
    :name="location.title"
    @destroy="destroy"
  )

  .row
    .col-md-7
      template(v-if="googleMapsConfigured")
        h2 Map
        Map(:location="location")

        hr

      h2 Stories
      StoriesTable(
        v-if="stories.length !== 0"
        :columns="COLUMNS"
        @sort="sortStories"
      )
      .alert.alert-info(v-if="stories.length === 0") No stories were found

    .col-md-5
      .row
        .col-md-12
          h3 Address
          LabelledValue(label="Address 1" :value="location.street1")
          LabelledValue(label="Address 2" :value="location.street2")

      .row
        .col-md-6
          LabelledValue(label="City" :value="location.city")

        .col-md-2
          LabelledValue(label="State" :value="location.state")

        .col-md-4
          LabelledValue(label="Zip" :value="location.zip?.toString()")

      .row
        .col-md-12
          h3 Contact Info
          LabelledValue(label="Phone 1" :value="location.phone1")
          LabelledValue(label="Phone 2" :value="location.phone2")
          LabelledValue(label="Fax" :value="location.fax")

      .row
        .col-md-12
          LabelledValue(label="Email" :value="location.email")

      .row
        .col-md-12
          h3 Other
          LabelledValue(label="Website" :value="location.website")
            a(:href="ensureScheme(location.website)" target="_blank") {{ preventScheme(location.website) }}
          LabelledValue(label="Description" :value="location.description")
</template>

<script>
  import { sync } from 'vuex-pathify'
  import { mapStores, mapState } from 'pinia'
  import { useLocationsStore } from '@/stores/locations'
  import { useLocationStore } from '@/stores/location'
  import store from '@/store'
  import { ensureScheme, preventScheme } from '@/utils/url_helpers'
  import { googleMapsConfigured } from '@/utils/google_config'

  import CommonHeader from '@/components/shared/common_header'
  import LabelledValue from '@/components/shared/labelled_value'
  import Map from '@/components/shared/map'
  import StoriesTable from '@/components/stories/index/stories_table'

  const COLUMNS = [
    'color',
    'id',
    'slug',
    'name',
    'media',
  ]

  export default {
    components: {
      CommonHeader,
      LabelledValue,
      Map,
      StoriesTable,
    },

    props: {
      locationId: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        loading: true
      }
    },

    computed: {
      ...mapStores(useLocationsStore),
      ...mapStores(useLocationStore),
      ...mapState(useLocationStore, ['location']),
      stories: sync('stories/stories'),
      googleMapsConfigured,

      name() {
        return this.location.title || this.location.street1
      }
    },

    async created() {
      this.COLUMNS = COLUMNS
    },

    async mounted() {
      const { locationId } = this

      await this.locationStore.fetch({ locationId })
      await this.fetchStories()

      this.loading = false
    },

    methods: {
      ensureScheme,
      preventScheme,

      fetchStories(queryAddons = {}) {
        return this.$store.dispatch(
          'stories/fetch',
          {
            query: {
              locations_id_eq: this.locationId,
              ...queryAddons
            },
            // We don't want to really do pagination at this level
            page: 1, prePage: 1000
          }
        )
      },

      sortStories({ column, direction }) {
        this.fetchStories({ s: `${column} ${direction}` })
      },

      destroy() {
        if(!confirm(`Sure you want to delete ${this.name}?`)) return

        this.locationsStore.destroy({ id: this.locationId })
          .then(() => {
            store.dispatch('messages/addNotice', 'Location deleted')

            this.$router.push({ name: 'locations' })
          })
      }
    }
  }
</script>
